import DefaultArticleHeader, {
  StandaloneArticleHeader,
  StandaloneArticleHeaderProps,
} from '@/components/ArticleHeader';
import { useStableProps } from '@/hooks/useStable';
import { LabradorComponent, StandaloneComponent } from '@/types/component';

const SvenskdamStandaloneArticleHeader: StandaloneComponent<StandaloneArticleHeaderProps> = (props) => {
  const stableProps = useStableProps({ options: { variant: 'first' } }, props);

  return <StandaloneArticleHeader {...stableProps} />;
};

const SvenskdamLabradorArticleHeader: LabradorComponent = ({ type, data, meta, descendants }) => {
  const { prominentTag } = data;

  return (
    <DefaultArticleHeader
      {...{ type, meta, descendants }}
      data={{
        ...data,
        tags: [prominentTag].filter(Boolean),
        format: 'DD MMM, YYYY, HH:mm',
      }}
    />
  );
};

export const standalone = SvenskdamStandaloneArticleHeader;

export default SvenskdamLabradorArticleHeader;
